import SearchResultPortal from './result-portal';

export { SearchResultPortal };
